<div class="card squirrel-card">
  <div class="card-body">
    <div class="row">
      <div class="col-md-12 project-user-board-body-table">
        @if (isLoadingResults || isRateLimitReached) {
          <div class="example-loading-shade">
            @if (isLoadingResults) {
              <mat-spinner></mat-spinner>
            }
            @if (isRateLimitReached) {
              <div class="example-rate-limit-reached">
                Squirrel's API rate limit has been reached. It will be reset in one minute.
              </div>
            }
          </div>
        }
        <ag-grid-angular style="width:100%; height: calc(100vh - 500px);" class="ag-theme-balham"
          [overlayLoadingTemplate]="overlayLoadingTemplate" [gridOptions]="gridOptions"
          (gridReady)="onGridReady($event)" [components]="components">
        </ag-grid-angular>
      </div>
    </div>
    <div class="row">
      <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 15px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
      (click)="cancel()" >Abbruch</button>
    </div>

  </div>
</div>